import React, { Component, Fragment  } from 'react';
import { 
    CREATE,
    Button,
    showNotification,
    translate
} from 'react-admin';
import SyncIcon from '../../icon/IcnSync';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import dataProvider from '../../dataProvider';
import SimpleButton from '@material-ui/core/Button';

const styles = {
    button: { marginRight: '1em', marginLeft: '1em' },
};

class ResourceSyncButton extends Component {
    state = {
        showDialog: false
    };

    handleClick = () => {
        this.setState({ showDialog: true });
    }

    handleCloseClick = () => {
        this.setState({ showDialog: false });
    };

    handleSubmit = () => {
        const {showNotification} = this.props;
        dataProvider(CREATE, 'resources', {})
        .then(() => {
            showNotification('resources.resources.notification.syncResourceStarted');
        })
        .catch((e) => {
            if (e.status == 404 && e.body.errorMessage === 'calendar_account_not_found'){
                showNotification('notification.calendarAccountNotFound', "warning");
            } else {
                showNotification('resources.resources.notification.syncResourceFailed', 'warning');
            }
        });
        this.setState({ showDialog: false });
    }

    render() {
        const { showDialog } = this.state;
        const { translate } = this.props; 
        return (
            <Fragment>
                <Button
                    size="small"
                    color="primary"
                    label='resources.resources.fields.syncResourceInfo'
                    onClick={this.handleClick}>
                    <SyncIcon />
                </Button>
                <Dialog
                    fullWidth
                    open={showDialog}
                    onClose={this.handleCloseClick}
                >
                    <DialogContent>
                        <DialogContentText>
                            <p>
                                {translate('resources.resources.fields.syncResourceGuidance1')}
                            </p>
                            <ul>
                                <li>
                                    {translate('resources.resources.fields.syncResourceGuidance2')}
                                </li>
                                <li>
                                    {translate('resources.resources.fields.syncResourceGuidance3')}
                                </li>
                                <li>
                                    {translate('resources.resources.fields.syncResourceGuidance4')}
                                </li>
                            </ul>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <SimpleButton
                            variant = 'raised'
                            onClick={this.handleSubmit}
                            color='primary'>
                            {translate('resources.resources.fields.startSyncResource')}
                        </SimpleButton>
                        <SimpleButton 
                            onClick={this.handleCloseClick}
                            color='primary'>
                            {translate('ra.action.cancel')}
                        </SimpleButton>
                    </DialogActions>
                </Dialog>
            </Fragment>
        );
    }
}

const enhance = compose(
    translate,
    connect(
        undefined,
        { showNotification }
    ),
    withStyles(styles)
);

export default enhance(ResourceSyncButton);